import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";

import Header from "./Header";
import Home from "./Home";
import Contact from "./Contact";
import About from "./About";
import FAQ from "./Faq";
// import Properties from "./Properties";
import ErrorPage from "./ErrorPage";
import Services from "./Services";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import TermsConditions from "../../pages/TermsConditions";

import PropertyPage2 from "../Property/PropertyPage2";
import PropertyList from "../../ui/PropertyList";

// BLOGS
import Blogs from "./Blogs";
import BlogDetails from "./BlogDetails";
import AdminLogin from "../DashBoard/AdminLogin";
import AdminRoute from "../DashBoard/AdminRoute";
import AdminPanel from "../Admin/AdminPanel";

// ADMIN


/* ================= USER LAYOUT ================= */
const AppLayout = () => {
  return (
    <div className="m-0 p-0 box-border">
      <Header />
      <Outlet />
    </div>
  );
};

/* ================= ROUTER ================= */
const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <AppLayout />,
      errorElement: <ErrorPage />,
      children: [
        { index: true, element: <Home /> },
        { path: "about", element: <About /> },
        { path: "contact", element: <Contact /> },
        { path: "faq", element: <FAQ /> },
        { path: "services", element: <Services /> },
        { path: "privacy-policy", element: <PrivacyPolicy /> },
        { path: "terms-and-conditions", element: <TermsConditions /> },

        /* ===== PROPERTIES (USER) ===== */
        { path: "properties", element: <PropertyList /> },
        { path: "property/:id", element: <PropertyPage2 /> },

        /* ===== BLOGS ===== */
        { path: "blogs", element: <Blogs /> },
        { path: "blog/:id", element: <BlogDetails /> },
      ],
    },

    /* ================= ADMIN (NO HEADER) ================= */
    {
      path: "/admin-login",
      element: <AdminLogin />,
    },
    {
      path: "/admin",
      element: (
        <AdminRoute>
          <AdminPanel />
        </AdminRoute>
      ),
    },
  ]);

  return <RouterProvider router={appRouter} />;
};

export default Body;
